// extracted by mini-css-extract-plugin
module.exports = {"ReviewsCarousels":"styles_ReviewsCarousels__EmS_l","bg_1":"styles_bg_1__IYkMf","bg_2":"styles_bg_2__oIRsQ","height":"styles_height__5zd2K"};